export default `
  <div class="wb-doc-page">
    <div class="doc-text doc-pt16">条件单风险声明</div>

    <div class="doc-text doc-pt16 doc-pb28">1. 条件单允许客户，可以预先设定某股票的触发条件。在有效日期之前，当股票价格触及预先设定的条件时（以下简称为触发），系统将会自动将客户预先设定的买卖指令，发送给交易所。条件单有效期内，触发条件只会被触发一次。触发系统送出预先设定的买卖指令，或期限到期时，条件单失效。任何时候，客户可以随时取消条件单或更改条件单内触发条件。条件单能有效协助客户，在市场出现大幅波动时，快速把握机会，或将风险及损失减至最低。 </div>

    <div class="doc-text doc-pb16">2. 条件单的触发要素主要包括「价格」及「时间」两种，两项条件可以同时设定，当客户下条件单时，必须同时输入触发后的指令，即以下信息：</div>
    <div class="doc-li doc-pb16">触发条件（即触发价格及／或时间）</div>
    <div class="doc-li doc-pb16">买卖方向 (即买出或卖出)</div>
    <div class="doc-li doc-pb16">股票代码</div>
    <div class="doc-li doc-pb16">委托数量</div>
    <div class="doc-li doc-pb16">委托价格</div>
    <div class="doc-text doc-pb28">当条件单对应的股票最新价格到达至上述的设定价格条件时，或时间达到设定时间条件时，视为触发。 </div>

    <div class="doc-text doc-pb28">3. 触发时，系统将会自动将预先设定的客户指令，送至交易所内执行。假如买卖指令并未能于当天成功执行，该买卖指令会于当天收市后自动取消。当预先设定的条件单仍然在有效期内，且未发生触发时，预先设定的买卖指令将不会被送至交易所内执行，该条件单会继续保留在账户内，直至有效期终止或客户取消条件单。 </div>

    <div class="doc-text doc-pb28">4. 客户须通过网上交易平台或APP下条件单。假如客户想更改条件单内的触发条件或取消条件单，亦需要通过网上交易平台或APP自行处理。条件单一经触发，客户预先设定的买卖指令即被送至交易所，该买卖指令为有效指令，客户作为指令发出人，需自行承担所有与指令有关的责任。盈宝证券国际(香港)有限公司 (“盈宝证券”)均不会因任何损失利润或损失机会、或任何间接、特别、随之发生的、偶发性、惩罚性损害或赔偿而对客户承担任何责任。 </div>

    <div class="doc-text doc-pb28">5. 当股票价格触及客户预先设定的触发条件时，条件单将有机会因客户当时账户内的持仓、资金、购买力及/或融资额度等，皆未能符合要求，而令系统无法将预先设定的买卖指令，送至交易所内执行。盈宝证券一概不会负责或保证客户预先设定的买卖指令，一定可以被送到交易所内执行。因此，在设定条件单前，客户应详细了解股票价格，也应详细了解，账户内的持仓、资金、购买力及/或融资额度是否已符合要求，避免触发后，因未能符合要求而无法将买卖指令送到交易所内执行。 </div>

    <div class="doc-text doc-pb28">6. 当设定条件单时，客户同时须要注意设定的委托价，可能因不同种类的买卖盘机制或距离市场实时价位的限制等因素，出现买卖指令无法送到交易所内执行。所以，客户设定条件单前，应先了解市场实时的状况及股票的波动。因条件单使用方法较一般买卖指令复杂，建议客户先清楚了解条件单的功能和运作后，才决定应否设定条件单及如何设定条件单。 </div>

    <div class="doc-text doc-pb28">7. 互联网是一个不完全稳定或绝对安全的数据传输及通讯媒体。由于互联网或流动电话网络传输速率或出现不稳定的原因，客户在获取股票信息时，有可能会出现滞后、延误或误差的情况。客户在处理网上交易平台或流动电话APP下条件单时，网络系统可能会出现中断、停顿、延迟、数据误差或不完整等情况，或计算器出现故障及互联网数据传输缓慢等原因，交易信号或指令可能会出现中断、停顿、延迟、数据误差或不完整等情况，由此等问题所产生的任何损失，盈宝证券皆不会承担任何责任。 </div>

    <div class="doc-text doc-pb28">8. 如果因为互联网或流动电话网络之通讯系统，出现故障、过于频繁、机房或服务器遭到破坏或负载过重，或受到网络黑客、病毒的攻击、入侵等原因，导致买卖交易出现延迟、停顿、中断、误差或系统接收出现错误信息，令条件单不能触发全部或部分的条件，由此产生的直接或间接的损失，盈宝证券皆不会承担任何责任。 </div>

    <div class="doc-text doc-pb28">9. 条件单是依据基本的市场规则和运作而制定。因此，客户在设定条件单前，应先清楚了解条件单内的功能、特性、操作重点和相关风险。客户须自行承担设定条件单后所有风险及令客户造成的直接或间接损失。包括，但不限于，不了解执行逻辑、大量买入股数的控制变量，或个人操作失误。客户须知悉设定条件单时，有可能存在出现误差，并可以导致客户预先设定的买卖指令出现误差、无效或失误。客户应谨慎操作，避免承担损失。 </div>

    <div class="doc-text doc-pb28">10. 由于电子化交易的特点，因此，客户要清楚知道，使用条件单成功执行的买卖指令，有时候，可能会出现与客户预先设定的买卖指令并不一致。但最后成交结果，皆以交易所的交易结果为准。客户须自行承担后果和责任。 </div>

    <div class="doc-text doc-pb28">11. 在使用条件单的过程中，可能因系统故障、网络问题或因预计技术未能克服等原因，导致条件单功能可能会出现误差或延迟，包括但不限于条件单未准确触发、误触发、到价未触发和到期限未触发等情况。盈宝证券不能够保证，条件单功能符合或达到客户的要求。亦不可以对盈宝证券网络服务及相关功能作出任何承诺。同时，也不会就上述服务的及时性、安全性、准确性而作出任何承诺。客户在设定条件单之前，应明确清楚，要为自己所设定的条件单承担所有风险和责任。 </div>

    <div class="doc-text doc-pb28">12. 盈宝证券会不定时对相关设备、网络或服务器进行检查或维修，以使网络的运作更快捷及更畅顺。从而造成在设定条件单的功能时，稍有延误。盈宝证券将尽力控制延误在最短时间内。但在该期间内的服务出现延误或中断，盈宝证券不会承担任何责任及损失。 </div>

    <div class="doc-text doc-pb16">注意事项</div>

    <div class="doc-li doc-pb16">条件单适用于港股市场及美股市场。 </div>
    <div class="doc-li doc-pb16">支持港股的增强限价单，美股的限价单及市价单。 </div>
    <div class="doc-li doc-pb16">对于港股市场，条件单在连续竞价交易时段（9:30-12:00、13:00-16:00）才会被触发，开市前集合竞价交易时段（9:00-9:20）及收市集合竞价交易时段（16:01-16:10）并不适用。 </div>
    <div class="doc-li doc-pb16">对于美股市场，条件单在所有交易时段内均可触发，包括盘前盘后，选择允许盘前盘后，则条件单会在盘前、盘中、盘后全时段监控并触发，提交的委托单也是允许盘前盘后的，不允许盘前盘后则同理。 </div>
    <div class="doc-li doc-pb16">下条件单时，暂不判断其可买、可卖数量是否足够，而是当条件触发时再判断。 </div>
    <div class="doc-li doc-pb28">可以设置有效时间。 </div>
  </div>
`
